import api from "./axios";

export const TimelineAPI = {
  add: async (entry: {
    dealId: number;
    type: string;
    message: string;
    documentId?: number;
  }) => {
    const res = await api.post(`/timeline`, entry);
    return res.data;
  },

  getByDeal: async (dealId: number) => {
    const res = await api.get(`/timeline/${dealId}`);
    return res.data;
  },
};
